import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';

import React from 'react';

interface UnlockItemModal {
  isOpen: boolean;
  onClose: () => void;
  currentItem: any;
  setStatus: any;
}

function UnlockItemModal({
  isOpen,
  onClose,
  currentItem,
  setStatus,
}: UnlockItemModal) {
  const toast = useToast();

  const unlockSelectedItem = async () => {
    try {
      const id = currentItem?.workListInventoryId;
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const validationResponse = await axios.delete(
          baseurl + '/Validation/Accounts/' + id,
          {
            headers: {
              Pragma: 'no-cache',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          }
        );
        if (validationResponse.data.success) {
          setStatus(false);
        } else {
          throw new Error('Failed to delete validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error deleting validation data:', error);
    }
  };

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center">Unlock Item</ModalHeader>
        <ModalCloseButton color="white" bg="#002677" />
        <ModalBody>
          <Table fontSize="15px" size="sm">
            <Tbody>
              <Tr>
                <Td fontWeight="bold">Account No:</Td>
                <Td>{currentItem.accountNo}</Td>
                <Td fontWeight="bold">Tracking No:</Td>
                <Td>{currentItem.trackingNo}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Region:</Td>
                <Td>{currentItem.RegionCode}</Td>
                <Td fontWeight="bold">Status:</Td>
                <Td
                  color={
                    currentItem.validationStatus === 'Success'
                      ? 'green'
                      : currentItem.validationStatus === 'Failed'
                      ? 'red'
                      : 'orange'
                  }
                >
                  {currentItem.validationStatus}
                </Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Health Plan Name:</Td>
                <Td>{currentItem.HealthPlanName}</Td>
                <Td fontWeight="bold">Hospital Name:</Td>
                <Td>{currentItem.HospitalName}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Plan Type:</Td>
                <Td>{currentItem.PlanType}</Td>

                <Td fontWeight="bold">Locked By:</Td>
                <Td>{currentItem.lockedBy}</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Validated On:</Td>
                <Td>
                  {currentItem.validatedOn
                    ? new Date(currentItem.validatedOn)
                        .toLocaleDateString()
                        .replace(/\//g, '-')
                    : ''}
                </Td>

                <Td fontWeight="bold">Comment:</Td>
                <Td>{currentItem.validationRemarks}</Td>
              </Tr>
            </Tbody>
          </Table>
        </ModalBody>
        <ModalFooter justifyContent=" center">
          <Button
            onClick={onClose}
            bg="#002677"
            color="white"
            h="30px"
            w="fit-content"
            mr="5px"
          >
            Cancel
          </Button>
          <Spacer />
          <Button
            bg="#002677"
            color="white"
            h="30px"
            w="fit-content"
            onClick={() => {
              unlockSelectedItem();
              onClose();
              toast({
                title: 'Item unlocked',
                position: 'top',
                description: 'This Item is now unlocked',
                status: 'success',
                duration: 9000,
                isClosable: true,
              });
            }}
          >
            Unlock
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UnlockItemModal;
